import { render } from "./InitLoader.vue?vue&type=template&id=7a4ab243&scoped=true"
import script from "./InitLoader.vue?vue&type=script&lang=js"
export * from "./InitLoader.vue?vue&type=script&lang=js"

import "./InitLoader.vue?vue&type=style&index=0&id=7a4ab243&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4ab243"]])

export default __exports__